import { render, staticRenderFns } from "./ConfirmVicePresident.vue?vue&type=template&id=7fd84bf3&"
import script from "./ConfirmVicePresident.vue?vue&type=script&lang=js&"
export * from "./ConfirmVicePresident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports